export default "__VITE_ASSET__8zeSRB1m__"